// Supporting text blocks are admin-authored rich text attached above or below one
// question, always shown or shown/hidden by a rule on the organization's answers. The
// value strings are the platform's (ethics-quotient
// specs/EA-234-supporting-text/contracts/supporting-texts.md).
export const SupportingTextPosition = {
    Above: 'above',
    Below: 'below',
};
export const SupportingTextVisibility = {
    /** No rule. */
    Always: 'always',
    ShowIf: 'show_if',
    HideIf: 'hide_if',
};
export const SupportingTextOperator = {
    /** The one listed option is selected (on a multi-select, among the picks). */
    Equals: 'equals',
    DoesNotEqual: 'does_not_equal',
    HasAnyOf: 'has_any_of',
    HasNoneOf: 'has_none_of',
};
/** The payload of a section without blocks; shared, so never mutate it. */
export const NO_SUPPORTING_TEXTS = { blocks: [], triggerAnswers: [] };
//# sourceMappingURL=types.js.map